import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';

export const JobAndPayDefaultColumnTypes: ColumnType[] = [
    {
        label: 'Reports To',
        relatedLabels: ['Reports To (Recommended)', 'Manager'],
        translatableLabel: 'import.columnTypes.reportsTo',
        serializeName: 'reportsToEmail',
        input: InputType.email,
        required: false,
    },
    {
        label: 'Stock Options',
        translatableLabel: 'import.columnTypes.stockOptions',
        serializeName: 'stockOptions',
        input: InputType.string,
        required: false,
    },
    {
        label: 'Additional Terms',
        translatableLabel: 'import.columnTypes.additionalTerms',
        serializeName: 'additionalTerms',
        input: InputType.string,
        required: false,
    },
    // TODO: Hide this for now, until we know when conditions when this will show
    // {
    //     label: 'Sync Payroll',
    //     serializeName: 'isPayrollSyncEnabled',
    //     input: InputType.boolean,
    //     options: BooleanOption,
    //     required: false,
    // },
];
